var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordPeek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "46px",
    viewBox: "0 0 80 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_eye_117126_000000",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.605,39.1877 C30.6402,39.1877 23.347,31.8947 23.347,22.9297 C23.347,13.9647 30.64,6.6717 39.605,6.6717 C48.57,6.6717 55.863,13.9647 55.863,22.9297 C55.863,31.8947 48.57,39.1877 39.605,39.1877 Z M39.605,11.6757 C33.398,11.6757 28.347,16.7265 28.347,22.9337 C28.347,29.1368 33.3978,34.1877 39.605,34.1877 C45.8122,34.1877 50.863,29.1369 50.863,22.9297 C50.863,16.7227 45.8122,11.6757 39.605,11.6757 L39.605,11.6757 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.605,45.8637 C15.238,45.8637 0.613,25.2347 0,24.3597 L0.054688,21.43 C0.714848,20.555 16.449688,0 39.605688,0 C62.761688,0 78.496688,20.555 79.156688,21.426 L79.211376,24.3557 C78.598096,25.23461 63.973376,45.8637 39.606376,45.8637 L39.605,45.8637 Z M5.253,22.9807 C8.9678,27.5041 21.48,40.8637 39.605,40.8637 C57.785,40.8637 70.25,27.5117 73.957,22.9847 C70.0351,18.4769 56.871,5.0007 39.605,5.0007 C22.296,5.0007 9.167,18.4657 5.253,22.9807 L5.253,22.9807 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordPeek);
export default ForwardRef;